import {
  useGetDiscountPercentages,
  useGetDiscountRanges,
} from '../../../product'
import { offerAccessorGetVolumePricing } from '../../model/offerAccessor/offerAccessorGetVolumePricing'
import { useProductPageContext } from '../productPageContext'

type UseGenerateVolumePricingBadgeDataProps = {
  discount?: number
  discountActivated?: boolean
  quantity?: number
}

/**
 * Gets information that will be displayed in the volume pricing badge:
 * 1. @returns discount: display inforamtion about percentage discount (ex. 6% Mengenrabatt aktiviert)
 * 2. @returns discountActivated: determines if the quantity is lower than first threshold, so we can display information about first threshold and how to achieve it (ex. ab 3 Stuck 6% sparen)
 * 3. @returns quantity
 */
export const useGenerateVolumePricingBadgeData =
  (): UseGenerateVolumePricingBadgeDataProps => {
    const {
      currentOffer,
      quantitySelectionControls: { quantity },
    } = useProductPageContext()
    const currentQuantity = quantity
    const volumePrices = offerAccessorGetVolumePricing(currentOffer) ?? []
    const ranges = useGetDiscountRanges(volumePrices)
    const { currentDiscountPercentage, firstDiscountPercentage } =
      useGetDiscountPercentages(ranges, currentQuantity)
    const firstMinTreshold = ranges[1]?.rangeStart ?? 0

    if (currentQuantity < firstMinTreshold) {
      return {
        discount: firstDiscountPercentage,
        discountActivated: false,
        quantity: firstMinTreshold,
      }
    }

    return {
      discount: currentDiscountPercentage,
      discountActivated: true,
      quantity: currentQuantity,
    }
  }
